import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import AnimatedSection from "./AnimatedSection";

interface Props {
  title: string;
  description: string;
  image: string;
  to: string;
  label?: string;
  delay?: number;
}

const ServiceCard = ({ title, description, image, to, label, delay = 0 }: Props) => (
  <AnimatedSection delay={delay} gentle>
    <Link to={to} className="group block h-full w-full">
      <div className="h-full overflow-hidden premium-surface focus-sharpen">
        {/* Mobile: fixed height crop for visual consistency. Desktop: 4/3 ratio. */}
        <div className="h-[220px] min-[769px]:h-auto min-[769px]:aspect-[4/3] overflow-hidden relative">
          <img
            src={image}
            alt={title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-[1.2s] ease-[cubic-bezier(0.22,0.68,0.35,1)] group-hover:scale-[1.03] group-active:scale-[1.015]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/[0.12] via-black/[0.02] to-transparent" />
          <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-[0.8s] bg-gradient-to-t from-black/[0.05] via-transparent to-transparent" />
        </div>
        <div className="p-6 min-[769px]:p-10">
          {label && (
            <p className="text-[10.5px] text-accent/80 min-[769px]:text-accent/50 font-body font-semibold uppercase tracking-[0.16em] mb-3 min-[769px]:mb-4">
              {label}
            </p>
          )}
          <h3 className="font-heading text-[1.35rem] min-[431px]:text-[1.45rem] text-foreground mb-3 min-[769px]:mb-4 tracking-tight leading-[1.2]">
            {title}
          </h3>
          <p className="text-[16px] min-[769px]:text-[13.5px] text-foreground/82 min-[769px]:text-muted-foreground/45 font-body leading-[1.6] min-[769px]:leading-[1.95] mb-6 min-[769px]:mb-10">
            {description}
          </p>
          <span className="inline-flex items-center gap-2 min-[769px]:gap-2.5 text-[12.5px] min-[769px]:text-[11px] font-semibold text-accent font-body uppercase tracking-[0.14em] min-[769px]:tracking-[0.12em] group-hover:gap-3.5 group-hover:text-accent transition-all duration-[0.6s] ease-[cubic-bezier(0.22,0.68,0.35,1)]">
            Ontdek meer
            <ArrowRight className="h-3.5 w-3.5 transition-all duration-[0.6s] ease-[cubic-bezier(0.22,0.68,0.35,1)] group-hover:translate-x-0.5" />
          </span>
        </div>
      </div>
    </Link>
  </AnimatedSection>
);

export default ServiceCard;
